import { Col, Row, Space, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

// react-slot pattern
type ItemLayoutProps = {
  left: string | JSX.Element;
  right: JSX.Element;
  required?: boolean;
};

const Container = styled.div`
  margin-top: 32px;
`;

const LeftContent = styled(Col).attrs({
  span: 3,
})`
  text-align: right;
`;

const RightContent = styled(Col).attrs({
  span: 18,
})``;

const { Text } = Typography;

export const ItemLayout = ({
  left,
  right,
  required,
}: ItemLayoutProps): JSX.Element => {
  return (
    <Container>
      <Row gutter={32}>
        <LeftContent offset={1}>
          <Space align="baseline" size={0}>
            <Text>{left}</Text>
            {required ? <Text type="danger">*</Text> : null}
          </Space>
        </LeftContent>
        <RightContent>{right}</RightContent>
      </Row>
    </Container>
  );
};
